const lang = {
    'caption': '立即下載，一鍵出發',
    'subtitle': '一鍵搜尋身旁最適合你的 GoShare 車輛，隨時輕鬆啟程！',
};

export default lang;
